import { BASH_TOOL_READONLY_ROOT } from "@phoenix/agent/tools/bash/bashToolFilesystemPolicy";

export const PHOENIX_ROOT = BASH_TOOL_READONLY_ROOT;
export const PHOENIX_META_ROOT = `${PHOENIX_ROOT}/_meta`;
